import React, { useState, useEffect } from "react";
import { getTranslations } from "../../Common/utils";

const MiniLeagueTabs = ({
  activeTab: propActiveTab = "Results",
  onTabChange = () => { },
  showPrizesTab = true,
}) => {
  const [currentTab, setCurrentTab] = useState(propActiveTab);

  useEffect(() => {
    setCurrentTab(propActiveTab);
  }, [propActiveTab]);

  const tabs = [
    {
      key: "Results",
      translationKey: "mini_league_tab_results",
      defaultText: "Results",
    },
    {
      key: "About",
      translationKey: "mini_league_tab_about",
      defaultText: "About",
    },
    ...(showPrizesTab
      ? [
          {
            key: "Prizes",
            translationKey: "mini_league_tab_prizes",
            defaultText: "Prizes",
          },
        ]
      : []),
  ];

  const handleTabClick = (tabKey) => {
    setCurrentTab(tabKey);
    onTabChange(tabKey);
  };

  return (
    <div className="si-miniLeagueTabs">
      <div className="si-miniLeagueTabs__menu">
        <ul>
          {tabs.map((tab, index) => (
            <li key={index} aria-label={tab.defaultText}>
              <button
                onClick={() => handleTabClick(tab.key)}
                className={currentTab === tab.key ? "si-active" : ""}
                aria-selected={currentTab === tab.key}
              >
                {getTranslations(tab.translationKey, tab.defaultText)}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MiniLeagueTabs;

